/**
 * /dashboard/hiring/reports — HR-admin hiring reports.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/hiring/reports/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { HiringModuleShell } from "@/components/shared/hiring-module-shell";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { ReportsTab } from "@/components/hiring/reports-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hiring/reports",
)({
  component: HiringReportsRoute,
});

function HiringReportsRoute() {
  return (
    <HiringModuleShell
      title="Hiring reports"
      description="Time-to-hire, source mix and pipeline health."
    >
      <HiringFeatureGate>
        <ReportsTab />
      </HiringFeatureGate>
    </HiringModuleShell>
  );
}
